// extracted by mini-css-extract-plugin
export var innerTooltip = "index-module--innerTooltip--dUv1N";
export var tooltip = "index-module--tooltip--tMaLq";